import styled, { css } from 'styled-components';

export const Container = styled.div<{ $open: boolean }>`
  position: fixed;
  width: ${({ $open }) => ($open ? '450px' : '0px')};
  height: 100vh;
  top: 0px;
  right: 0px;
  /* height: 100vh; */
  z-index: 999;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  overflow: hidden;
  transition: width 0.3s ease;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.07); /* 우측에 그림자 추가 */
`;

export const Sidebar = styled.div`
  height: 100%;
  top: 0px;
  right: 0px;
  position: sticky;
  background-color: white;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontsize.header_semi};
  overflow-x: hidden;
  overflow-y: scroll;
  /* position: fixed; */
  min-width: 450px;
  max-width: 450px;
`;

export const ContainerFlipper = styled.div`
  width: 25px;
  height: 100%;
  text-align: center;
  align-content: center;
  background-color: ${({ theme }) => theme.colors.darkGray};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

export const HeaderImgDiv = styled.div`
  width: 100%;
  padding: 30px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Menu = styled.div<{ $focus?: boolean }>`
  height: 40px;
  padding: 0px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 500;
  &:hover {
    background-color: ${({ theme }) => theme.colors.darkNavy};
  }
  ${(props) =>
    props.$focus &&
    css`
      color: ${({ theme }) => theme.colors.blue};
    `}
`;

export const MenuItem = styled.div<{ $focus?: boolean }>`
  padding: 5px 20px 5px 43px;
  width: 100%;
  height: 28px;
  cursor: pointer;

  /* line-height: 18px; */
  &:hover {
    background-color: ${({ theme }) => theme.colors.brightNavy};
  }
  ${(props) =>
    props.$focus &&
    css`
      color: ${({ theme }) => theme.colors.blue};
    `}
`;

export const MenuItemWrapper = styled.div<{
  $show: boolean;
  $itemLength: number;
}>`
  width: 100%;
  overflow: hidden;
  height: ${({ $show, $itemLength }) =>
    $show ? `${$itemLength * 38}px` : '0px'};
  transition: height 0.5s ease;
`;
